import React, { Suspense, FC } from 'react';
import { useTranslation } from 'react-i18next';

import DataCardsBg from '../../../images/company/contribute-card-bg.png';
import BgIconBlue from '../../../images/company/icon-bg-blue.svg';
import BgIconLBlue from '../../../images/company/icon-bg-lblue.svg';
import GhIconBlue from '../../../images/footer/icon-gh-blue.svg';
import GhIconLBlue from '../../../images/footer/icon-gh-lblue.svg';
import YtIconBlue from '../../../images/footer/icon-yt-blue.svg';
import YtIconLBlue from '../../../images/footer/icon-yt-lblue.svg';
import {
  ContributeStyled,
  LeftColumn,
  RightColumn,
  Title,
  Text,
  TextBlue,
  Card,
} from './style';

interface Props {}

const Contribute: FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <Suspense fallback={<div />}>
      <ContributeStyled>
        <div className="container">
          <LeftColumn>
            <Title>{t('CompanyContributeTitle')}</Title>
            <Text>{t('CompanyContributeText1')}</Text>
            <TextBlue>{t('CompanyContributeTextBlue')}</TextBlue>
            <Card
              dangerouslySetInnerHTML={{
                __html: t('CompanyContributeCardText'),
              }}
            />
            <Text
              dangerouslySetInnerHTML={{
                __html: t('CompanyContributeText2'),
              }}
            />
            <div className="social">
              <a
                href="https://muttdata.ai/blog/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={BgIconBlue} alt="social" />
                <img src={BgIconLBlue} alt="social" />
                <span>{t('CompanyContributeBlog')}</span>
              </a>
              <a
                href="https://github.com/MuttData"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={GhIconBlue} alt="social" />
                <img src={GhIconLBlue} alt="social" />
                <span>{t('CompanyContributeRepository')}</span>
              </a>
              <a
                href="https://www.youtube.com/channel/UCzQyAiNmw4os0sTB0v5D4WA"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={YtIconBlue} alt="social" />
                <img src={YtIconLBlue} alt="social" />
                <span>{t('CompanyContributeMeetup')}</span>
              </a>
            </div>
          </LeftColumn>
          <RightColumn>
            <img src={DataCardsBg} alt="logo" />
            <Card
              dangerouslySetInnerHTML={{
                __html: t('CompanyContributeCardText'),
              }}
            />
          </RightColumn>
        </div>
      </ContributeStyled>
    </Suspense>
  );
};

export default Contribute;
